import {gsap} from "gsap";

export default function ui(){
    const toggleBtn = document.getElementById('toggleBtn')
    const toggleBtnDesc = document.getElementById('toggleBtnDesc')
    const arrow = document.getElementById('arrow')
    const buttonArrow = document.getElementById('buttonArrow')
    const sidebar = document.getElementById('sidebar')
    const mainRadios = document.querySelectorAll('input[name="main"]')
    const sidewallsRadios = document.querySelectorAll('input[name="sidewalls"]')
    const tableRadios = document.querySelectorAll('input[name="table"]')
    const equipmentCheckbox = document.querySelectorAll('input[name="equipment"]')
    const materialRadios = document.querySelectorAll('input[name="material"]')
    const panels = document.querySelectorAll(".panel")
    const accordions = document.querySelectorAll('.accordion');


    let isOpen = true;

    const currentSize = window.innerWidth > 1024 ? -360 : -300


    toggleBtn.addEventListener('click', () => {
        open()
    });

    toggleBtnDesc.addEventListener('click', () => {
        open()
    });

    function open(){
        if (isOpen) {
            gsap.to(sidebar, {
                x: currentSize,
                duration: 0.3,
                ease: 'power2.out'
            })

            gsap.to(arrow, {
                rotate: 0,
                transformOrigin: '50% 50%',
                duration: 0.3,
                ease: 'power2.out'
            })

            gsap.to(buttonArrow, {
                rotate: 90,
                transformOrigin: '50% 50%',
                duration: 0.2,
                ease: 'power2.out'
            })

            gsap.to(toggleBtn, {
                x: currentSize,
                duration: 0.3,
                ease: 'power2.out'
            })

            gsap.to(toggleBtnDesc, {
                x: currentSize,
                duration: 0.3,
                ease: 'power2.out'
            })
        } else {
            gsap.to(sidebar, {
                x: 0,
                duration: 0.3,
                ease: 'power2.out'
            })

            gsap.to(arrow, {
                rotate: 180,
                transformOrigin: '50% 50%',
                duration: 0.3,
                ease: 'power2.out'
            })

            gsap.to(buttonArrow, {
                rotate: -90,
                transformOrigin: '50% 50%',
                duration: 0.2,
                ease: 'power2.out'
            })

            gsap.to(toggleBtn, {
                x: 0,
                duration: 0.3,
                ease: 'power2.out'
            })

            gsap.to(toggleBtnDesc, {
                x: 0,
                duration: 0.3,
                ease: 'power2.out'
            })
        }

        isOpen = !isOpen
    }

    accordions.forEach((btn, i) => {
        const symbol = btn.querySelector('.symbol')

        const dataSpan = btn.querySelector('.accordion-data')
        const radios = panels[i].querySelectorAll('input[type="radio"]')

        radios.forEach(radio => {
            radio.addEventListener('change', () => {
                if (!radio.dataset.text) return
                dataSpan.textContent = radio.dataset.text

            })
        })

        const checked = panels[i].querySelector('input[type="radio"]:checked')
        if (checked?.dataset.text) {
            dataSpan.textContent = checked.dataset.text
        }

        const checkedCheckbox = panels[i].querySelectorAll('input[type="checkbox"]')
        const hasUnChecked = Array.from(checkedCheckbox).some(cb => !cb.checked);

        checkedCheckbox.forEach(el => {
            el.addEventListener('change', () => {
                const hasUnChecked = Array.from(checkedCheckbox).some(cb => !cb.checked);

                hasUnChecked  ? dataSpan.textContent = 'Custom': dataSpan.textContent = 'Full'
            })
        })

        if (checkedCheckbox.length > 0){
            hasUnChecked  ? dataSpan.textContent = 'Custom': dataSpan.textContent = 'Full'
        }


        panels[i].classList.toggle("open")
        panels[i].style.height = "auto"
        symbol.textContent = '−'

        btn.addEventListener("click", () => {
            panels[i].classList.toggle("open")

            if(panels[i].classList.contains("open")){
                panels[i].style.height = "auto"
                panels[i].style.padding = ""
                symbol.textContent = '−'

                return
            }

            panels[i].style.height = 0
            panels[i].style.padding = 0
            symbol.textContent = '+'
        });
    });

    return{
        mainRadios,
        equipmentCheckbox,
        sidewallsRadios,
        materialRadios,
        tableRadios
    }
}